import { Chat } from "@phosphor-icons/react"
import { TableSummary } from "~/components/TableSummary"

export const CampaignSummary = ({ data }: { data: any }) => {
  const stats = [
    {
      id: "sent",
      title: "Messages Sent",
      value: data?.messages_sent?.aggregate?.count,
      intentClass: "text-blue-500",
      valueClassName: "text-blue-500 !font-400",
      titleClassName: "text-[#155DFC]",
      bgClass: "bg-[#EFF6FF]",
      borderClassName: "border-1 border-[#BEDBFF]",
    },
    {
      id: "delivered",
      title: "Delivered",
      value: data?.messages_delivered?.aggregate?.count,
      intentClass: "text-[#0B4F4A]",
      valueClassName: "text-[#0B4F4A] !font-400",
      titleClassName: "text-[#009689]",
      bgClass: "bg-[#F0FDFA]",
      borderClassName: "border-1 !border-[#96F7E4]",
    },
    {
      id: "read",
      title: "Opened/Read",
      value: data?.messages_read?.aggregate?.count,
      intentClass: "text-[#B33500]",
      valueClassName: "text-[#B33500] !font-400",
      titleClassName: "text-[#F54900]",
      bgClass: "bg-[#FFF7ED]",
      borderClassName: "border-1 !border-[#F6B092]",
    },
    {
      id: "enquiries",
      title: "Enquiries",
      value: data?.total_enquiries?.aggregate?.count,
      intentClass: "text-[#59168B]",
      valueClassName: "text-[#59168B] !font-400",
      titleClassName: "text-[#9810FA]",
      bgClass: "bg-[#FAF5FF]",
      borderClassName: "border-1 !border-[#E9D4FF]",
    },
    // {
    //   id: "callback",
    //   title: "Callback",
    //   value: data?.callback?.aggregate?.count,
    //   intentClass: "text-[#487412]",
    //   valueClassName: "text-[#487412] !font-400",
    //   titleClassName: "text-[#6DC701]",
    //   bgClass: "bg-[#F7FFEE]",
    //   borderClassName: "border-1 !border-[#C7F392]",
    // },
  ]
  return (
    <div className="rounded-xl p-4 flex flex-col gap-3 border-1 border-gray-300 rounded-xl bg-gray-100">
      <header className="flex items-center gap-2">
        <Chat size={18} weight="bold" className="text-gray-600" />
        <span className="font-600 text-gray-800 text-sm">
          WhatsApp Campaign Summary
        </span>
      </header>
      <div className="grid grid-cols-4 gap-3">
        <TableSummary summary={stats} />
      </div>
    </div>
  )
}
